// extracted by mini-css-extract-plugin
export var base = "_4j-0";
export var updateBanner = "_4j-1";